import { Stack } from "@mui/material";

import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";

import Header from "./Header";

type PageHeaderProps = {
    children?: ReactNode;
    title?: string;
    sx?: SxProps<Theme>;
};

export default function PageHeader({ children, title, sx }: PageHeaderProps) {
    return <Stack direction="row" alignItems="center" justifyContent="space-between" mb={ 5 } sx={ sx }>
        <Header text={ title } type="h4"/>
        { children }
    </Stack>
}
